import { StarFilterData } from '@apeiron/star'
import { FetchJsonProps, useReactQueryFetchJson } from '@apeiron/temp'
import ENV_CONFIG from '@src/config'
import { starFilterDataSchema } from '@src/deserialize/yup/starFilter'

const useFetchStarFilterJson = (props?: FetchJsonProps) => {
  const { fetchNow } = props || {}

  return useReactQueryFetchJson<StarFilterData>({
    fetchNow,
    path: ENV_CONFIG.JSON_FILE_NAME.STAR_FILTERS,
    deserialize: response =>
      starFilterDataSchema.cast(response) as StarFilterData
  })
}

export default useFetchStarFilterJson
